import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const BoxStyled = styled(Box).attrs({
  my: { sm: '300' },
  justifyContent: { sm: 'space-between' },
  pr: { sm: '400' },
})`
  ${({ theme }) => css`
    background: ${theme.colors.grey[100]};
    border: 1px dashed ${theme.colors.grey[300]};
    border-radius: ${theme.spacings[200]};
  `}
`;

export const SkewedBoxStyled = styled(Box).attrs({ py: { sm: '450' }, pr: { sm: '450' }, pl: { sm: '100' } })`
  ${({ theme }) => css`
    position: relative;
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      transform: skewX(-15deg);
      background: ${theme.colors.white};
      top: 0;
      right: ${theme.spacings[300]};
    }
  `}
`;

export const SkewedBoxStyledDark = styled(Box).attrs({
  py: { sm: '450' },
  pr: { sm: '450' },
  pl: { sm: '100' },
  ml: { sm: '500' },
})`
  ${({ theme }) => css`
    position: relative;
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      transform: skewX(-15deg);
      background: ${theme.colors.grey[200]};
      top: 0;
      right: ${theme.spacings[300]};
    }
  `}
`;
